import { Component } from 'react'
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function Copyright(props:any) {
  return (
    
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.globalnursingagency.com.au/">
        RosterMe.io
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

export default class Footer extends Component {
  render() {
    return (
        <Copyright sx={{ pt: 4 }} />
    )
  }
}
